export default __webpack_public_path__ + "ea85aaff72f3ada9c6ed4d143d003cc1.woff2";